
export default {
  'entityName': 'training_category',
  pagination: {
    'itemsPerPage': 10,
    'page': 1,
    'sortBy': 'id',
    'descending': true
  },
  filterStorage: {},
  'fields': [

    {
      value: 'old_code',
      text: 'OLD Code',
      'type': 'text',
      'table': {
        'sortable': true,
        'filter': true
      },
    },

    
    {
      value: 'name',
      text: 'Name',
      type: 'text',
      'table': {
        'sortable': true,
        'filter': true
      },
      'validators': [
        'required',
      ],
      default: null,
    },

    {
      md:12,
      "value": "image",
      "text": "Image",
      "type": "image",
    },

    // {
    //   full: true,
    //   "value": "file_id",
    //   "text": "Image",
    //   "type": "component",
    //   "name": "app-file-upload",
    //   "bind" : (field) => {
    //     return { 
    //       label: "Trascina qui l'immagine che vuoi caricare",
    //       entity: "training_category",
    //       entityId: field.item.id
    //     }
    //   },
    //   on: () => {
    //   },
    //   visible: (item) => {
    //     return item.id
    //   },
    //   'table': {
    //     'sortable': false,
    //     'filter': false
    //   },
    //   render: (item) => {
    //     return item.image.name
    //   }
    // }
  

  ],
  actions: [
    'upsert','remove'
  ]
}
